import * as NetworkUtilities from "../utilities/networkUtilities";

export class BaseRepository {
  constructor(dispatch, loginReducer, persistItemsReducer, navigate) {
    this.dispatch = dispatch;
    this.loginReducer = loginReducer;
    this.persistItemsReducer = persistItemsReducer;
    this.navigate = navigate;
    this.baseURL = loginReducer?.getSOConfiguration?.soBaseUrl;
  }

  /**
   * A helper to get authentication headers.
   * @returns {Promise<object>}
   */
  async getHeaders() {
    return await NetworkUtilities.getHeadersWithTokenRefresh(
      this.persistItemsReducer,
      this.loginReducer,
      this.dispatch,
      this.navigate
    );
  }
}